// Meta Pixel utility functions

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

export const initMetaPixel = () => {
  // Check if already initialized
  if (window.fbq) return

  // Set up fbq function
  const n: any = (window.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  })
  if (!window._fbq) window._fbq = n
  n.push = n
  n.loaded = true
  n.version = '2.0'
  n.queue = []

  // Load the Facebook Pixel script safely
  const t = document.createElement('script')
  t.async = true
  t.src = 'https://connect.facebook.net/en_US/fbevents.js'
  document.head.appendChild(t)

  window.fbq('init', '1424056906028921')
  window.fbq('track', 'PageView')

  // Add noscript fallback image
  const noscript = document.createElement('noscript')
  const img = document.createElement('img')
  img.height = 1
  img.width = 1
  img.style.display = 'none'
  img.src =
    'https://www.facebook.com/tr?id=1424056906028921&ev=PageView&noscript=1'
  noscript.appendChild(img)
  document.body.appendChild(noscript)
}

export const trackAddToCart = () => {
  if (window.fbq) {
    window.fbq('track', 'AddToCart')
  }
}
